import axios from 'axios';
import { API_BASE_URL } from './api';

export const fetchPaymentMethods = async () => {
  const response = await axios.get(`${API_BASE_URL}/payment-master/all-methods`);
  return response.data.data;
};

export const fetchSettlementModes = async () => {
  const response = await axios.get(`${API_BASE_URL}/payment-master/modes`);
  return response.data.data; // [{ payment_method, bank_payment_code }]
};

export const fetchBankDetailsByCode = async (code) => {
  if (!code) return null;
  const response = await axios.get(`${API_BASE_URL}/payment-master/bank-details/${encodeURIComponent(code)}`);
  return response.data.data; // { bank_name, bank_branch, bank_account_number }
};